var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        { staticClass: "filters", attrs: { inline: "" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "服务商" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择服务商" },
                  on: { change: _vm.loadAll },
                  model: {
                    value: _vm.platformId,
                    callback: function ($$v) {
                      _vm.platformId = $$v
                    },
                    expression: "platformId",
                  },
                },
                _vm._l(_vm.platforms, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.platformName, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh" },
                  on: { click: _vm.loadAll },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-alert", {
        staticClass: "alert",
        attrs: {
          title:
            "草稿由绑定的开发小程序上传；可在这里将草稿添加为模板，并管理模板库。",
          type: "info",
          closable: false,
          "show-icon": "",
        },
      }),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "草稿箱", name: "draft" } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.draftLoading,
                      expression: "draftLoading",
                    },
                  ],
                  attrs: { data: _vm.drafts, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "draftId", label: "草稿ID", width: "90" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "sourceMiniProgram",
                      label: "开发小程序",
                      "min-width": "150",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "sourceMiniProgramAppId",
                      label: "AppID",
                      "min-width": "185",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "userVersion",
                      label: "版本号",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "userDesc",
                      label: "版本描述",
                      "min-width": "220",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "developer", label: "上传者", width: "120" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "上传时间", width: "170" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.formatTime(scope.row.createTime))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "100", fixed: "right" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:wechat:open-platform:config",
                                    ],
                                    expression:
                                      "['admin:wechat:open-platform:config']",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                  loading:
                                    _vm.operationKey ===
                                    "add-" + scope.row.draftId,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAdd(scope.row)
                                  },
                                },
                              },
                              [_vm._v("添加模板")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "模板库", name: "template" } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.templateLoading,
                      expression: "templateLoading",
                    },
                  ],
                  attrs: { data: _vm.templates, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "templateId", label: "模板ID", width: "90" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "sourceMiniProgram",
                      label: "来源小程序",
                      "min-width": "145",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "sourceMiniProgramAppId",
                      label: "AppID",
                      "min-width": "185",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "userVersion",
                      label: "版本号",
                      width: "110",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "userDesc",
                      label: "版本描述",
                      "min-width": "220",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "developer", label: "上传者", width: "120" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "创建时间", width: "170" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.formatTime(scope.row.createTime))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "90", fixed: "right" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:wechat:open-platform:config",
                                    ],
                                    expression:
                                      "['admin:wechat:open-platform:config']",
                                  },
                                ],
                                staticClass: "danger-text",
                                attrs: {
                                  type: "text",
                                  loading:
                                    _vm.operationKey ===
                                    "delete-" + scope.row.templateId,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(scope.row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }